import { render, staticRenderFns } from "./AssignedDelegationsChip.vue?vue&type=template&id=54487f9a&scoped=true&"
import script from "./AssignedDelegationsChip.vue?vue&type=script&lang=js&"
export * from "./AssignedDelegationsChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54487f9a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54487f9a')) {
      api.createRecord('54487f9a', component.options)
    } else {
      api.reload('54487f9a', component.options)
    }
    module.hot.accept("./AssignedDelegationsChip.vue?vue&type=template&id=54487f9a&scoped=true&", function () {
      api.rerender('54487f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Booking/AssignedDelegationsChip.vue"
export default component.exports